module.exports = __webpack_public_path__ + "static/media/camera-lens-cap2.60265958.aac";